// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2TD9g","info":"Note_info__3DVWe","note":"Note_note__2KzK6","actions":"Note_actions__2HOIh"};